import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { AccommodationService, MoveData } from '../../accommodation.service';

@Component({
	selector: 'app-accommodation-list-reservations',
	templateUrl: './accommodation-list-reservations.component.html',
	styleUrls: ['./accommodation-list-reservations.component.css'],
})
export class AccommodationListReservationsComponent implements OnInit, OnDestroy {
	@Input() reservations: Array<any> = [];
	@Input() identifier: string = null;
	@Output() selected = new EventEmitter();
	private reservationSubscription: Subscription;

	constructor(public service: AccommodationService) {}

	ngOnInit(): void {
		if (this.identifier != 'reservations') {
			return;
		}
		this.reservationSubscription = this.service.move.subscribe(<MoveData>(data) => {
			switch (data.type) {
				case 'dok':
					switch (data.step) {
						case 'begin':
							this.reservations.map((reservation) => {
								if (['1', '36'].includes(reservation.roomType)) {
									reservation.styles.border = '3px solid red';
								} else {
									reservation.styles.visibility = 'hidden';
								}
								return reservation;
							});
							break;
						case 'selected':
							this.reservations.map((reservation) => {
								delete reservation.styles.border;
								delete reservation.styles.visibility;
								return reservation;
							});
							break;
					}
					break;
			}
		});
	}

	ngOnDestroy(): void {
		if (this.reservationSubscription) {
			this.reservationSubscription.unsubscribe();
		}
	}

	select(reservation, reservations) {
		// ja pierdole, ale cyganstwo
		// wykrywa czy wybrano dokwaterowanie po obramowaniu diva :facepalm:
		if (reservation.styles.border) {
			this.service.move.next({
				type: 'dok',
				step: 'selected',
				reservation: reservation,
				previous: reservations,
			});
			return;
		}
		this.selected.emit(reservation);
	}
}
